import { useState, useEffect } from "react";
import config from "../config/config";
import { userSession } from "../observers/userObserver";

const useExchanges = () => {
    const [exchanges, setExchanges] = useState([]);

    useEffect(() => {
        const fetchExchanges = async () => {
        try {
            const storedExchanges = localStorage.getItem("exchanges");
            if (storedExchanges) {
                setExchanges(JSON.parse(storedExchanges)); // Use cached data
                return;
            }

            const response = await fetch(`${config["backend-url"]}/recognised_exchange`, {
                method: 'GET',
                headers: {
                  Authorization: `Bearer ${userSession.getToken()}`,
                  'Content-Type': 'application/json'
                }
              });
            const data = await response.json();
            if (response.ok) {
                setExchanges(data);
                localStorage.setItem("exchanges", JSON.stringify(data)); // Cache data
            }
        } catch (error) {
            console.error("Error fetching exchanges:", error);
        }
        };

        fetchExchanges();
    }, []);

  return exchanges;
};

export default useExchanges;
